import nonIndexableMeta from '../data/nonIndexableMeta.json';

export const LEGAL_META = nonIndexableMeta.legal;
export const AUTH_META = nonIndexableMeta.auth;
export const TOKEN_META = nonIndexableMeta.token;

export function getLegalMeta(path) {
  return LEGAL_META[path] || null;
}

export function getAuthMeta(path) {
  return AUTH_META[path] || null;
}

export function getTokenMeta(path) {
  return TOKEN_META[path] || null;
}
